;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('integrationService', integrationServiceFactory)

  function integrationServiceFactory(
    $translate,
    dialogs,
    logger,
    csTemplates,
    ApplicationFactory,
    WebhookFactory,
    BugtrackerFactory,
    JobOutcomePolicyFactory,
    ErrorService,
    NOTIFICATION_TYPE_OPTIONS,
    INTEGRATION_TYPE
  ) {
    'ngInject'

    function removeOption(array, value) {
      var index = _.indexOf(array, value)
      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    function fillWebhook(model, data) {
      model.name = data.name
      model.url = data.url
      model.all_applications = data.all_applications
      model.app_criterion = data.app_criterion
      model.id = data.id
      model.type = data.webhook_type
      model.valid = data.valid

      angular.forEach(data.properties, function (prop) {
        if (prop.propertyName === 'token') {
          model.properties.token = prop.propertyValue
        } else if (prop.propertyName === 'roomId') {
          model.properties.roomId = parseInt(prop.propertyValue)
        } else if (prop.propertyName === 'useHTML') {
          model.use_html = prop.propertyValue === 'true'
        } else if (prop.propertyName === 'message_type') {
          model.properties.message_type = prop.propertyValue
        } else if (prop.propertyName === 'sendFailureNotification') {
          model.send_failure_notification = prop.propertyValue === 'true'
        } else if (prop.propertyName === 'integration_key') {
          model.properties.integration_key = prop.propertyValue
        }
      })

      if (data.all_applications) {
        model.all_applications = true
        model.applications = [NOTIFICATION_TYPE_OPTIONS.ALL]
      } else {
        model.all_applications = false
        angular.forEach(data.applications, function (app) {
          model.applications.push(app.app_id)
        })
      }

      if (data.payload) {
        model.payload = data.payload
      }
    }

    function _deleteIntegration(title, msg, type, id, webhook) {
      var transl = {
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel')
      }

      return dialogs
        .confirm(title, msg, {
          size: 'md-sm',
          yes: transl.action_delete,
          no: transl.action_cancel
        })
        .result.then(function () {
          switch (type) {
            case INTEGRATION_TYPE.JIRA:
            case INTEGRATION_TYPE.VSTS:
            case INTEGRATION_TYPE.GITHUB:
            case INTEGRATION_TYPE.AGILE_CENTRAL:
              return BugtrackerFactory.deleteBugtracker(id)
            case INTEGRATION_TYPE.JENKINS:
              return JobOutcomePolicyFactory.deleteJobOutcomePolicy(id)
            default:
              break
          }

          return WebhookFactory.deleteIntegration(webhook.id)
        })
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
          return true
        })
        .catch(function (response) {
          if (response != 'no') {
            ErrorService.processError(response)
          }
        })
    }

    var service = {
      deleteIntegration: deleteIntegration,
      getDeleteTemplate: getDeleteTemplate,
      addApplication: addApplication,
      removeApplication: removeApplication,
      getApplications: getApplications,
      getWebhook: getWebhook,
      testSlackUrl: testSlackUrl,
      testPagerDutyConnection: testPagerDutyConnection,
      testVictorOpsConnection: testVictorOpsConnection,
      testMicrosoftteamsConnection: testMicrosoftteamsConnection,
      onUrlSelectChange: onUrlSelectChange,
      updateEditableFields: updateEditableFields
    }

    return service

    function deleteIntegration(webhook, type, id, addWarning) {
      var includeWarning = angular.isDefined(addWarning) ? addWarning : false

      type = webhook.webhook_type || type

      var transl = {
        title_integrationsSettings_deleteConfig: $translate.instant(
          'title_integrationsSettings_deleteConfig'
        ),
        title_integrationsSettings_deleteBugtrackerConfig: $translate.instant(
          'title_integrationsSettings_deleteBugtrackerConfig'
        ),
        title_integrationsSettings_deleteJobOutcomePolicy: $translate.instant(
          'title_integrationsSettings_deleteJobOutcomePolicy'
        ),
        detail_unableToLoadRemoveDialog: $translate.instant(
          'detail_unableToLoadRemoveDialog'
        )
      }

      var title

      switch (type) {
        case INTEGRATION_TYPE.JENKINS:
          title = transl.title_integrationsSettings_deleteJobOutcomePolicy
          break
        default:
          title = transl.title_integrationsSettings_deleteConfig
          break
      }

      var template = this.getDeleteTemplate(
        webhook.webhook_type || type,
        includeWarning
      )

      return csTemplates
        .loadAndInterpolate(template, { integrationName: webhook.name })
        .then(
          function (interpolatedStr) {
            return _deleteIntegration(title, interpolatedStr, type, id, webhook)
          },
          function () {
            logger.logError(transl.detail_unableToLoadRemoveDialog)
          }
        )
    }

    function getDeleteTemplate(type, includeWarning) {
      switch (type) {
        case INTEGRATION_TYPE.SLACK:
          return 'views/settings/integrations/template/slack.tpl.html'
        case INTEGRATION_TYPE.GENERIC:
          return 'views/settings/integrations/template/generic.tpl.html'
        case INTEGRATION_TYPE.JIRA:
          if (includeWarning) {
            return 'views/settings/integrations/template/jira_warning.tpl.html'
          } else {
            return 'views/settings/integrations/template/jira.tpl.html'
          }
        case INTEGRATION_TYPE.MICROSOFTTEAMS:
          return 'views/settings/integrations/template/microsoftteams.tpl.html'
        case INTEGRATION_TYPE.VSTS:
          return 'views/settings/integrations/template/vsts.tpl.html'
        case INTEGRATION_TYPE.GITHUB:
          return 'views/settings/integrations/template/github.tpl.html'
        case INTEGRATION_TYPE.AGILE_CENTRAL:
          return 'views/settings/integrations/template/agile_central.tpl.html'
        case INTEGRATION_TYPE.JENKINS:
          return 'views/settings/integrations/template/jenkins.tpl.html'
        default:
          return 'views/settings/integrations/template/webhook.tpl.html'
      }
    }

    function addApplication($scope, model) {
      if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
        $scope.model.all_applications = true
        $scope.model.applications = [NOTIFICATION_TYPE_OPTIONS.ALL]
      } else {
        $scope.model.applications = removeOption(
          $scope.model.applications,
          NOTIFICATION_TYPE_OPTIONS.ALL
        )
        $scope.model.all_applications = false
      }
    }

    function removeApplication($scope, model) {
      if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
        $scope.model.all_applications = false
      } else {
        $scope.model.applications = removeOption(
          $scope.model.applications,
          model
        )
      }

      if ($scope.model.applications.length == 0) {
        $scope.model.applications = [NOTIFICATION_TYPE_OPTIONS.ALL]
        $scope.model.all_applications = true
      }
    }

    function getApplications(scope) {
      var transl = {
        title_allApplications: $translate.instant('title_allApplications')
      }

      return ApplicationFactory.getApplicationBase(false).then(function (
        response
      ) {
        scope.select.applications.push({
          value: NOTIFICATION_TYPE_OPTIONS.ALL,
          name:
            transl.title_allApplications +
            ' (' +
            response.data.applications.length +
            ')'
        })

        var applications = response.data.applications

        for (var pos = 0; pos < applications.length; pos++) {
          scope.select.applications.push({
            value: applications[pos].app_id,
            name: applications[pos].name
          })
        }
      })
    }

    function getWebhook(id, scope) {
      return WebhookFactory.getWebhook(id).then(function (response) {
        fillWebhook(scope.model, response.data.webhook)
      })
    }

    function testSlackUrl(url) {
      return WebhookFactory.testWebhook({
        type: INTEGRATION_TYPE.SLACK,
        url: url
      })
    }

    function testMicrosoftteamsConnection(url) {
      return WebhookFactory.testWebhook({
        type: INTEGRATION_TYPE.MICROSOFTTEAMS,
        url: url
      })
    }

    function testVictorOpsConnection(url, messageType) {
      return WebhookFactory.testWebhook({
        type: INTEGRATION_TYPE.VICTOROPS,
        url: url,
        message_type: messageType
      })
    }

    function testPagerDutyConnection(url, messageType, integrationKey) {
      return WebhookFactory.testWebhook({
        type: INTEGRATION_TYPE.PAGERDUTY,
        url: url,
        message_type: messageType,
        integration_key: integrationKey
      })
    }
  }

  function onUrlSelectChange(select) {
    var search = select.search
    var list = angular.copy(select.items)

    list = list.filter(function (item) {
      return item.id !== undefined
    })

    if (!search) {
      select.items = list
    } else {
      var userInput = {
        id: undefined,
        name: 'New credentials',
        username: $scope.model.username,
        password: $scope.model.password,
        host: search
      }
      select.items = [userInput].concat(list)
      select.selected = userInput
    }
  }

  function updateEditableFields($scope) {
    $scope.model.password = ''
    $scope.form.username.$setPristine()
    $scope.form.password.$setPristine()
    $scope.allowEditCredentials = false
  }
})()
